export const imageSize = {
    width: "56px",
    height: "50px"
};

export const navButtons = {
    backgroundColor: "#163172",
    height: "8vh",
    color: "white",
    fontSize: "1.2rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "right",
    paddingRight: "30px",
    columnGap: "10px"
};

export const navTitle = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    backgroundColor: "#163172",
    height: "8vh",
    color: "white",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: "20px",
    columnGap: "10px"
};

export const navSignIn = {
    cursor: "pointer"
};

export const navbarSignedIn = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "30px",
    columnGap: "20px"
};

export const basket = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "10px",
    cursor: "pointer"
};

export const subNavStyle = {
    position: "absolute",
    width: "10%",
    zIndex: "4",
    visibility: "visible",
    backgroundColor: "white",
    right: "5px"
};

export const subMenuButton = {
    height: "40px",
    padding: "10px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    flex: "1",
    alignItems: "center"
};

export const profileButtons = {
    cursor: "pointer"
};

export const lineSetparator = {
    margin: 0,
    padding: 0
};

export const body = {
    position: "fixed",
    zIndex: "2",
    width: "100%"
};
